import { API_ROUTES } from "../../../routes";
import { HTTP_METHODS } from "../../../utils/constants";

import dialxyApi from "..";

const voiceSDKApi = dialxyApi.injectEndpoints({
  endpoints: (build) => ({
    listMyProviders: build.query({
      query: () => ({
        url: API_ROUTES.providers.list,
      }),
    }),
    postForVoipProvider: build.mutation({
      query: ({ data }) => ({
        url: API_ROUTES.communication.provider,
        method: HTTP_METHODS.POST,
        body: data,
      }),
      invalidatesTags: ["CallLog"],
    }),
    postForVoiceAccessToken: build.mutation({
      query: ({ data }) => ({
        url: API_ROUTES.communication.webToken,
        method: HTTP_METHODS.POST,
        body: { providerId: data },
      }),
      // invalidatesTags: ['CallLog'],
    }),
    postFCMToken: build.mutation({
      query: (data) => ({
        url: API_ROUTES.device.fcm,
        method: HTTP_METHODS.POST,
        body: data,
      }),
      // invalidatesTags: ['CallLog'],
    }),
  }),
});

export const {
  useListMyProvidersQuery,
  usePostForVoipProviderMutation,
  usePostForVoiceAccessTokenMutation,
  usePostFCMTokenMutation,
} = voiceSDKApi;
